import { z } from 'zod';
// ============================================================
// Prompt Block Schemas
// ============================================================
export const PromptBlockTypeSchema = z.enum(['STYLE', 'POSE', 'WARDROBE', 'CAMERA']);
export const PromptBlockSchema = z.object({
    id: z.string(),
    blockType: PromptBlockTypeSchema,
    slug: z.string().max(64),
    nameKo: z.string().max(128),
    nameEn: z.string().max(128),
    promptText: z.string(),
    isBuiltin: z.boolean(),
    isActive: z.boolean(),
    sortOrder: z.number().int(),
    createdAt: z.string().or(z.date()),
    updatedAt: z.string().or(z.date()),
});
export const PromptBlockSelectionSchema = z.object({
    styleSlug: z.string(),
    poseSlug: z.string(),
    wardrobeSlug: z.string(),
    cameraSlug: z.string(),
});
// ============================================================
// API Request/Response Schemas
// ============================================================
export const CreatePromptBlockSchema = z.object({
    blockType: PromptBlockTypeSchema,
    slug: z.string().min(1).max(64).regex(/^[A-Z0-9_]+$/, 'slug은 대문자 영숫자 + 언더스코어만 허용'),
    nameKo: z.string().min(1).max(128),
    nameEn: z.string().min(1).max(128),
    promptText: z.string().min(1),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
export const UpdatePromptBlockSchema = z.object({
    nameKo: z.string().min(1).max(128).optional(),
    nameEn: z.string().min(1).max(128).optional(),
    promptText: z.string().min(1).optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
export const PromptBlockListResponseSchema = z.object({
    blocks: z.array(PromptBlockSchema),
});
//# sourceMappingURL=prompt-blocks.js.map